<template>
    <el-container>
        <el-main>
            <el-form :model="searchData" label-position="top" label-width="80px">
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label="字典名称" prop="dictName" class="cls-col">
                            <el-input v-model="searchData.dictName" placeholder="字典名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="字典类型" prop="dictType" class="cls-col">
                            <el-input v-model="searchData.dictType" placeholder="字典类型" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item style="margin-top: 41px;">
                            <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item style="margin-top: 41px;margin-left:-151px;">
                            <el-button
                            type="primary"
                            plain
                            icon="el-icon-plus"
                            size="mini"
                            @click="handleAdd"
                            >新增字典类型</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form> 
           
            <el-table
                    :data="typeList"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                >
                <el-table-column
                        type="index"
                        label="序号"
                        width="50" :index="indexMethod">
                </el-table-column>
                <!-- <el-table-column label="字典编号" align="center" prop="dictId" /> -->
                <el-table-column label="字典名称" align="center" prop="dictName"/>
                <el-table-column label="字典类型" align="center" prop="dictType">
                    <template slot-scope="scope">
                        <span style="color:#20a0ff;cursor: pointer;" @click="showDictData(scope.row)">{{ scope.row.dictType }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'">{{ scope.row.status === '0' ? '可用' : '禁用' }}</el-tag>
                    </template>
                </el-table-column>                
                <el-table-column label="备注" align="center" prop="remark"/>
                <el-table-column label="创建时间" align="center" prop="createTime" width="180"  :formatter="dateFormat"/>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button
                        type="text"
                        @click="handleUpdate(scope.row)"
                    >修改</el-button>
                    <el-button
                        type="text"
                        @click="handleDelete(scope.row)"
                    >删除</el-button>
                    </template>
                </el-table-column>                
            </el-table>
            <!-- 分页组件 -->
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchData.total"
                :page-sizes="[10, 20, 50]"
                :page-size="searchData.pageSize"
                :current-page.sync="searchData.pageNumber"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
                style="margin-top: 10px; float: right; margin-right: 10px"
            ></el-pagination>
        </el-main>
        <!-- 添加或修改参数配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="字典名称" prop="dictName">
            <el-input v-model="form.dictName" placeholder="请输入字典名称" />
            </el-form-item>
            <el-form-item label="字典类型" prop="dictType">
            <el-input v-model="form.dictType" placeholder="请输入字典类型" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
                <el-radio key="0" label="0">可用</el-radio>
                <el-radio key="1" label="1">禁用</el-radio>
            </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
        </el-dialog>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'
    export default {
        name: "Dict",
        components: {            
        },
        data() {           
            return {
                 // 遮罩层
                loading: true,
                typeList:[],
                // 弹出层标题
                title: "",
                // 是否显示弹出层
                open: false,             
                searchData: {
                    pageNumber: 1,
                    pageSize: 10,
                    dictName: '',
                    dictType: '',
                    status: ''
                },         
                // 表单参数
                form: {
                    dictId: null,
                    dictName: '',
                    dictType: '',
                    status: "0",
                    remark: ''
                },
                // 表单校验
                rules: {
                    dictName: [
                    { required: true, message: "字典名称不能为空", trigger: "blur" }
                    ],
                    dictType: [
                    { required: true, message: "字典类型不能为空", trigger: "blur" }
                    ],
                    status: [
                    { required: true, message: "状态不能为空", trigger: "blur" }
                    ]
                }
            }
        },
        methods: {   
            search(val) {
                let params = this.searchData;
                console.log('param',params);
                https.fetchGet('/sysDictType/list',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                console.log('data',data);
                let code = data.status;
                if(code == '200') {
                    this.typeList = data.data.list
                    console.log(' this.typeList', this.typeList);
                    // 2. 更新分页信息
                    this.searchData.total = data.data.total;
                    this.searchData.pageNumber = data.data.pageNum;
                    this.loading = false;

                }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            },  
             handleSizeChange(val) {
                this.searchData.pageSize = val
                this.search()
            },
            handlePageChange(val) {
                this.searchData.pageNumber = val
                this.search()
            },
            // 格式化序号
            indexMethod(index) {
                return (this.searchData.pageNumber - 1) * this.searchData.pageSize + index + 1
            },  
            // 取消按钮
            cancel() {
                this.open = false;
                this.reset();
            },
            // 表单重置
            reset() {
                this.form = {
                    dictId: null,
                    dictName: '',
                    dictType: '',
                    status: "0",
                    remark: ''
                };
            },  
            /** 新增按钮操作 */
            handleAdd() {
                this.reset();
                this.open = true;
                this.title = "添加字典类型";
            }, 
            /** 提交按钮 */
            submitForm: function() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                if (this.form.dictId != undefined) {
                    https.fetchPost('/sysDictType/editDictType',this.form,"json" ).then((data) => {
                        console.log('data',data);
                        let code = data.status;
                        if(code == '200') {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.open = false;
                            this.search();
                        }
                    }).catch(err=>{
                            console.log(err)
                        }
                    )
                } else {
                    https.fetchPost('/sysDictType/addDictType',this.form,"json" ).then((data) => {
                        console.log('data',data);
                        let code = data.status;
                        if(code == '200') {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.open = false;
                            this.search();
                        }
                    }).catch(err=>{
                            console.log(err)
                        }
                    )
                }
                }
            });
            },
            /** 修改按钮操作 */
            handleUpdate(row) {
              this.reset();
              const dictId = row.dictId;
              this.form = row;
              this.open = true;
              this.title = "修改字典类型";
            },
            /** 删除按钮操作 */
            handleDelete(row) {
            const dictId = row.dictId;
            this.$confirm('确认删除名称为"'+ row.dictName +'"的数据项?,是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            let params = {'dictId': dictId};
            https.fetchPost('/sysDictType/deleteDictType', params, 'json').then((data) => {
                let code = data.data.code;
                let msg = data.data.msg;
                if (code == '200') {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.search();
                } else {
                this.$message({
                    type: 'info',
                    message: '删除失败：' + msg
                });
                }
            }).catch(err => {
                    this.$message.error('网络异常！');
                }
            );
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });
            });
            },                                        
            showDictData(row){
                console.log(row);
                this.$router.push({
                    name: 'DictDataList',
                    params: row
                });
            },             
        },
        created: function () {
            this.search();
        }
    }
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
</style>